module.exports = __webpack_public_path__ + "components/flag/static/square/sj-3aed0ce5148d18a7984129e8da993f0c.svg";